import { MDSButton, MDSButtonIcon, MDSButtonSlotName, MDSButtonVariant } from "@/mds";
import { MdsIconKind } from "@/design-system/components/icon";
import styled from "@emotion/styled";
import { windowModule } from "@/modules/window";

type TProps = {
  openBtnProps: {
    url: string;
    title: string;
  };
};

export const FloatingPreviewActions = ({ openBtnProps }: TProps) => {
  const { url, title } = openBtnProps;

  return (
    <Container>
      <MDSButton
        variant={MDSButtonVariant.Contrast}
        onClick={() => {
          windowModule.openInNewTab({
            url: new URL(url),
          });
        }}
      >
        <MDSButtonIcon slot={MDSButtonSlotName.LeftIcon} kind={MdsIconKind.ExternalLink} /> {title}
      </MDSButton>
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xs};
  justify-content: flex-end;
  padding: ${({ theme }) => theme.spacing["0.5"]} ${({ theme }) => theme.spacing["4"]};
`;
